import React, { createContext, useState, useEffect } from "react";

// Create the UserContext
export const EnquiryContext = createContext();

const ENQUIRY_STORAGE_KEY = "enquiry";

// Create a provider component
export const EnquiryProvider = ({ children }) => {
    // Prefer sessionStorage for enquiry PII (cleared when the tab closes)
    const storedEnquiry = (() => {
        try {
            return JSON.parse(sessionStorage.getItem(ENQUIRY_STORAGE_KEY)) || null;
        } catch {
            return null;
        }
    })();

    const [enquiry, setEnquiry] = useState(storedEnquiry);

    // Update sessionStorage whenever the enquiry changes
    useEffect(() => {
        if (enquiry !== null) {
            sessionStorage.setItem(ENQUIRY_STORAGE_KEY, JSON.stringify(enquiry));
        } else {
            sessionStorage.removeItem(ENQUIRY_STORAGE_KEY);
        }
    }, [enquiry]);

    return (
        <EnquiryContext.Provider value={{ enquiry, setEnquiry }}>
            {children}
        </EnquiryContext.Provider>
    );
};
